import { render, staticRenderFns } from "./tabZfdetails1.vue?vue&type=template&id=5eea7bdc&"
import script from "./tabZfdetails1.vue?vue&type=script&lang=js&"
export * from "./tabZfdetails1.vue?vue&type=script&lang=js&"
import style0 from "./tabZfdetails1.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "tabZfdetails1.vue"
export default component.exports